
import { initCarousel } from './_carousel';
import {initDialog, toggleDialog, closeDialog} from './_dialog'
import { introAnimation } from './_intro';

var app;
var appLoaded = false;
var modalRouteNewsLoaded = false;
var currentPath;
var disableScrollTop = false;
var lastRoute;

(function ($) {

	'use strict';
	var nfForm = $('.js-nf-content');
	var nfVisible = false;
	
	app = $.sammy('#app', function(context) {

		this.before('.*', function() {
			if (!(/^\/news\/(.*)/i.test(lastRoute)))
				disableScrollTop = false;
			if (nfVisible) {
				$('.js-nf-docker').html(nfForm);
				$('.js-nf-content').hide();
				nfVisible = false;
			}
			var active = this.path.substring(1, this.path.length);
			
			if (active != '') $('.jsLogo').show();
			currentPath = this.path;
			
			if (!(/news/i.test(currentPath))) {
				modalRouteNewsLoaded = false;
			}

			if (!(/^\/news\/(.*)/i.test(currentPath))) {
				$('.main-menu__item--' + active).addClass('is-active');
				$('.footer-menu__item--' + active).addClass('is-active');
			}
			closeDialog();
		});

		this.before('/', function() {
			$('body').addClass('is-route-home');
			$('html, body').addClass('is-fixed');
		});

		this.before({except: {path: '/'}}, function() {
			$('body').removeClass('is-route-home');
			$('html, body').removeClass('is-fixed');
			$('.l-intro-wrapper').addClass('is-hidden');
			$('.jsLogo').stop(true).fadeTo(0, 1, function() {});
			$('.jsMain').addClass('is-section-loading');
		});

		this.get('/', function(context) {
			introAnimation();
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-home')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
				initDialog();
				initCarousel();
			});
		});

		this.get('/about', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-page&id=9')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
				$('.page-title-toggle').first().next('p').slideToggle(400);
				$('.page-title-toggle').click(function(event) {
					$(this).next('p').slideToggle(400);
				});
			});
		});

		this.get('/news', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-news')
			.then(function(){
				if (!modalRouteNewsLoaded)
					context.app.swap('');
			})
			.then(function(item){
				if (!modalRouteNewsLoaded) {
					context.$element().append(item);
					initDialog();
					modalRouteNewsLoaded = true;
				}
				afterAppLoaded();
			});
		});

		this.get(/^\/news\/(.*)/, async function() {
			try {
				let splat = this.params['splat']; // slug (warning: it seems to be an array)
				let postId;
				console.log('Loading news post:', splat)
				disableScrollTop = true;
				// Load posts via AJAX if not already loaded
				if (!modalRouteNewsLoaded) {
					const item = await this.load(a2ei_ajax_object.ajaxurl + '?action=ajax-template-news')
					context.$element().append(item);
					afterAppLoaded();
					initDialog();
					modalRouteNewsLoaded = true;
				}
				// Display post
				let ajaxPost = $('#' + splat);
				if (!ajaxPost.length) {
					console.log('No post found, searching via old-slug:', `[data-old-slug="${splat}"]`)
					ajaxPost = $(`[data-old-slug="${splat}"]`);
					if (!ajaxPost.length) {
						throw new Error("Post not found: " + splat);
					}
				}
				console.log('Found post:', ajaxPost)
				postId = ajaxPost.data('id');
				toggleDialog(postId);
			} catch (err) {
				console.error('Failed to get post', err);
				alert("Failed to load post:\n" + (err?.message ?? JSON.stringify(err)));
			}
		});

		this.get('/supporters-and-staff', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-supporters')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				initCarousel();
				afterAppLoaded();
			});
		});

		this.get('/advisory-board', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-advisory_board')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
				initDialog();
			});
		});

		this.get('/data', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-data')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				$('.js-nf-container').html(nfForm);
				nfVisible = true;
				$('.js-nf-content').show();
				afterAppLoaded();
			});
		});

		this.get('/jobs', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-jobs')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
				initDialog();
			});
		});

		this.get('/contact', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-page&id=6')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
			});
		});

		this.get('/why-pink', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-page&id=36')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
			});
		});

		this.get('/datenschutz', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-page&id=3')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
			});
		});

		this.get('/impressum', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-page&id=53')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
			});
		});

		this.get('/newsletter', function(context) {
			this.load(a2ei_ajax_object.ajaxurl+'?action=ajax-template-newsletter')
			.then(function(){
				context.app.swap('');
			})
			.then(function(item){
				context.$element().append(item);
				afterAppLoaded();
			});
		});

		this.after(function(callback) {
			// $.get('.*', function() { - this would call REST on every nav - didn't see the need, so I disabled it, seems to work fine
				lastRoute = currentPath;
				$('.jsBody').addClass('is-app-loaded');
				if (!disableScrollTop) {
					$('.jsScrollWrapper').scrollTop(0);
				}
				$('.jsMain').removeClass('is-section-loading');
			// }); - end of $.get('.*')
		});
		

	});

})(jQuery);

function afterAppLoaded() {
	appLoaded = true;
	(function ($) {
		$('.jsMain').addClass('is-section-appended');
	})(jQuery);
}

export default app;